const CREATE_NEW_SLIDE = 'Create new slide'
const START_PRESENTING = 'start presenting'

export {
  CREATE_NEW_SLIDE,
  START_PRESENTING,
}
